import { supabase } from "@/lib/supabase/client";

const TX_COLUMNS = "id,status,amount,currency,created_at";

export async function getMyPendingCashPayment() {
  const { data, error } = await supabase
    .from("payment_transactions")
    .select(TX_COLUMNS)
    .eq("status", "pending")
    .eq("payment_method", "cash")
    .eq("transaction_type", "activation")
    .order("created_at", { ascending: false })
    .limit(1);
  if (error) throw error;
  return data[0] || null;
}

export async function requestCashPayment() {
  const { data, error } = await supabase.rpc("request_cash_payment");
  if (error) throw error;
  return data;
}

export async function verifyCashPayment(transactionId, code) {
  const { error } = await supabase.rpc("verify_cash_payment", { p_payment_transaction_id: transactionId, p_verification_code: code });
  if (error) throw error;
}

const CASH_ERRORS = [
  [/not been issued|not issued/i, "Your verification code hasn't been issued yet. Pay QAR 50 cash to the MetWorth team quoting your reference first."],
  [/expired/i, "This verification code has expired. Ask the MetWorth team for a new one."],
  [/too many|attempts|locked/i, "Too many incorrect attempts. Please contact the MetWorth team for help."],
  [/already/i, "This payment is already verified. Refreshing your activation…"],
  [/invalid|incorrect|does not match|mismatch|wrong/i, "That code isn't correct. Check it and try again."],
  [/entitlement|activat/i, "Your payment was received but activation couldn't be completed. Please contact the MetWorth team."],
];

export function cashErrorMessage(err) {
  if (!err?.code && /fetch|network/i.test(err?.message || "")) return "We couldn't reach MetWorth. Check your connection and try again.";
  const hit = CASH_ERRORS.find(([re]) => re.test(err?.message || ""));
  return hit ? hit[1] : "Something went wrong. Please try again.";
}

export const formatAmount = (tx) => `${tx.currency} ${(tx.amount / 100).toFixed(tx.amount % 100 ? 2 : 0)}`;
